export function handleEvent(eventName, {onElement, withCallback, useCapture = false} = {}, thisArg) {

    const element = onElement || document.documentElement;

    function handler(event) {
        if (typeof withCallback === 'function') {
            withCallback.call(thisArg, event);
        }
    }

    handler.destroy = function () {
        return element.removeEventListener(eventName, handler, useCapture);
    };

    element.addEventListener(eventName, handler, useCapture);
    return handler;
}

export const stringToDOM = (string = '') => {
    const fragment = document.createDocumentFragment();
    const wrapper = fragment.appendChild(document.createElement('div'));

    wrapper.innerHTML = string.trim();
    return wrapper.children[0];
};

export function index(element) {
    let sib = element.parentNode.childNodes,
        n = 0;

    for (let i = 0; i < sib.length; i++) {
        if (sib[i] === element) return n;
        if (sib[i].nodeType === 1) n++;
    }

    return -1;
}

export function eq(parent, index) {
    return (index >= 0 && index < parent.length) ? parent[index] : -1;
}

export function lerp(a, b, n) {
    return ((1 - n) * a) + (n * b);
}

export function getDevice() {
    let device = window.getComputedStyle(document.body, '::after').getPropertyValue('content');
    device = device.replace(/('|")/g, '');

    return device;
}

export function calculateRatio(width, height) {
    return width / height;
}

export function whichTransitionEvent() {
    const el = document.createElement('fakeelement');

    let transitions = {
        transition: 'transitionend',
        OTransition: 'oTransitionEnd',
        MozTransition: 'transitionend',
        WebkitTransition: 'webkitTransitionEnd',
    };

    for (const t in transitions) {
        if (typeof el.style[t] !== 'undefined' && transitions.hasOwnProperty(t)) {
            return transitions[t];
        }
    }
}

export function transitionEnd() {
    const transEndEventNames = {
        WebkitTransition: 'webkitTransitionEnd',
        MozTransition: 'transitionend',
        OTransition: 'oTransitionEnd',
        msTransition: 'MSTransitionEnd',
        transition: 'transitionend',
    };
    return transEndEventNames[Modernizr.prefixed('transition')];
}

export function getLanguage() {
    let lang;

    if (navigator.languages) {
        // chrome does not currently set navigator.language correctly https://code.google.com/p/chromium/issues/detail?id=101138
        // but it does set the first element of navigator.languages correctly
        lang = navigator.languages[0];
    } else if (navigator.userLanguage) {
        // IE only
        lang = navigator.userLanguage;
    } else {
        // as of this writing the latest version of firefox + safari set this correctly
        lang = navigator.language;
    }

    return lang;
}

export function animateShadows(el) {
    const tl = new TimelineMax();

    tl.to(el.querySelector('#shadow-position'), 2, {
        attr: {
            dx: 6,
            dy: 6,
        },
        ease: Power0.easeNone,
    }).to(el.querySelector('#flood'), 2, {
        attr: {
            'flood-opacity': '0.4',
        },
        delay: 0.1,
        ease: Power0.easeNone,
    }, '-=2');
}



/** WEBPACK FOOTER **
 ** ./base/utils.js
 **/